import { BentoModel, BentoImageModel } from '@/models/Bento.model';

import PushBento from '@/components/marketing/PushBento';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

import styles from './Bento.module.scss';

const BENTO_LAYOUT_IMAGE_COUNT: Record<string, number> = {
  LAYOUT_3: 3,
  LAYOUT_4: 4,
};

const BentoImage = ({ size, ...image }: BentoImageModel & { size?: 'large' | 'small' }) => (
  <PushBento
    url={image.link}
    contentTitle={image.title}
    desc={image.description}
    label={image.labelButton}
    informations={image.condition}
    hasButton={image.hasButton}
    hasArrowIcon={image.hasArrowIcon}
    hasOverlay={image.hasOverlay}
    img={image.img}
    alt={image.alt}
    size={size}
  />
);

export const Bento = ({ bento }: { bento: BentoModel }) => {
  const { isMobile } = useScreenSizeContext();

  const expectedImageCount = BENTO_LAYOUT_IMAGE_COUNT[bento?.layout ?? ''];
  const isLayoutValid = !!expectedImageCount && bento?.bentoImages?.length === expectedImageCount;

  if (isMobile || !bento || !isLayoutValid) {
    return null;
  }

  const { layout, bentoImages } = bento;

  return (
    <div className={styles.container}>
      <BentoImage {...bentoImages[0]} size="large" />
      <div className={styles.right}>
        <BentoImage {...bentoImages[1]} />
        {layout === 'LAYOUT_3' ? (
          <BentoImage {...bentoImages[2]} />
        ) : (
          <div className={styles.bottom}>
            <BentoImage {...bentoImages[2]} />
            <BentoImage {...bentoImages[3]} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Bento;
